jQuery(document).ready(function() {

    if(jQuery('.sidebar-arrow i').length > 0 ) {
        jQuery('.sidebar-arrow i').click(function() {
            jQuery(this).removeClass('fa-chevron-circle-right');
            jQuery(this).removeClass('fa-chevron-circle-left');
            if(jQuery(this).parent().parent().parent().parent().hasClass('clicked')) {
                jQuery(this).parent().parent().parent().parent().removeClass('clicked');
                jQuery(this).addClass('fa-chevron-circle-right');
            } else {
                jQuery(this).parent().parent().parent().parent().addClass('clicked');
                jQuery(this).addClass('fa-chevron-circle-left');
            }

        });
    }

});

jQuery('body').on('click', '.manage-sidebar-link', function(e) {
    var type = jQuery(this).attr('id');
    var data = {user_id: window.current_user, business_id: (window.business?window.business.business_id:null), type: type};
    var url = "/feedback/get-manage-sidebar-link";
    var manage_url = window.manage_server;

    jQuery.get(url, data, function(result) {

        window.open( manage_url + "/index/sso?token="+ result, '_blank');
    });
});

jQuery('body').on('click', '#more', function() {
    jQuery(this).find('i').removeClass('fa-folder');
    jQuery(this).find('i').removeClass('fa-folder-open');
    if(jQuery(this).hasClass('open')){ //close the thing
        jQuery(this).find('.text').text("More");
        jQuery(this).removeClass('open');
        jQuery(this).find('i').addClass('fa-folder');
        jQuery('body').find('.sidebar-expander').hide();
    } else { //open the thing
        jQuery(this).find('.text').text("Less");
        jQuery(this).addClass('open');
        jQuery(this).find('i').addClass('fa-folder-open');
        jQuery('body').find('.sidebar-expander').show();
    }
});

jQuery(document).ready(function() {
    if(jQuery('.sidebar-expander').find('.active').length > 0) {
        jQuery('#more').find('.text').text("Less");
        jQuery('#more').addClass('open');
        jQuery('#more').find('i').addClass('fa-folder-open');
        jQuery('body').find('.sidebar-expander').show();
    }
});

// AI Summary Reports - parent menu element
jQuery('body').on('click', '.reports', function() {
    var $reportsContainer = jQuery('.reports-container');

    if ($reportsContainer.hasClass('hide')) {
        $reportsContainer.removeClass('hide');
    } else {
        $reportsContainer.addClass('hide');
    }
});

// Digital Glove Box - parent menu element
jQuery('body').on('click', '.dgb', function(e) {
    e.preventDefault();
    jQuery('.dgb-container').toggleClass('hide');
});
